/* eslint-disable no-unused-vars */

import moment from 'moment';
import _ from 'lodash';

import { PERMISSIONS } from 'permissions/constants';
import TasksSelector from 'selectors/tasks/tasks.selector';
import InspectionSelector from 'selectors/inspection/inspection.selector';
import CheckSelector from 'selectors/checks/check.selector';
import HSEEventSelector from 'selectors/hse/hse-event.selector';

export const taskTypeData = async ({ store, permissions }) => {
  const { auth, cache, inspection, tasks, picklists } = store;
  const userId = auth.userId || '';
  const allWOTasks = (await TasksSelector.getTasks({ store })) || [];

  const allAssignedWorkOrders = allWOTasks?.filter((task) =>
    task.newWorkOrder && task?.status !== 'To do'
      ? task?.responsible?.[0]?.woUserRequestId === userId
        ? true
        : false
      : task?.status === 'Synced'
      ? !task?.isNew
        ? true
        : false
      : !task.newWorkRequest
  );

  const newWorkOrderList = allWOTasks?.filter((task) =>
    (task.newWorkOrder || task?.entityType === 'WorkOrder') &&
    task?.responsible?.[0]?.woUserRequestId !== userId &&
    task?.status !== 'To do' &&
    task?.status !== 'Synced'
      ? true
      : task?.status === 'Synced' && task?.isNew && task?.entityType !== 'WorkRequest'
      ? true
      : false
  );

  const newWorkRequestList =
    allWOTasks?.filter((task) => task.newWorkRequest || task?.entityType === 'WorkRequest') || [];

  const allDoneWOTasks = allAssignedWorkOrders.filter((task) => task?.status === 'Synced');
  const allNotDoneWOTasks = allAssignedWorkOrders.filter((task) => task?.status !== 'Synced');

  const allInspectionTasks = (await InspectionSelector.getInspections({ store })) || [];
  const allDoneInspectionTasks = allInspectionTasks.filter((task) => task?.status === 'Synced');
  const allNotDoneInspectionTasks = allInspectionTasks.filter((task) => task?.status !== 'Synced');

  const allCheckTasks = (await CheckSelector.getAllChecks({ store })) || [];
  const allDoneCheckTasks = allCheckTasks.filter((task) => task?.status === 'Synced');
  const allNotDoneCheckTasks = allCheckTasks.filter((task) => task?.status !== 'Synced');

  const allHseEvents = (await HSEEventSelector.getHSEEvents({ store })) || [];

  const allTasksList = allTasksWithPermissions({
    permissions,
    allWOTasks,
    allInspectionTasks,
    allCheckTasks
  });
  const allDoneTasks = allTasksList.filter((task) => task?.status === 'Synced');
  const allNotDoneTasks = allTasksList.filter((task) => task?.status !== 'Synced');

  const today = moment().format('YYYY-MM-DD');
  const isOverDue = allNotDoneTasks.find((task) =>
    task.dueDate ? moment(task.dueDate).isBefore(today) : false
  );
  const isWOOverDue = allNotDoneWOTasks.find((task) =>
    task.dueDate ? moment(task.dueDate).isBefore(today) : false
  );
  const IsInspectionOverDue = allNotDoneInspectionTasks.find((task) =>
    task.dueDate ? moment(task.dueDate).isBefore(today) : false
  );
  const IsCheckOverDue = allCheckTasks.find((task) =>
    task.dueDate ? moment(task.nextDue).isBefore(today) : false
  );

  // New or edited assets count

  const {
    equipments: cacheEquipments = [],
    sitesMap,
    sites,
    sitesEquipmentsMap = {},
    syncedNewAndEditedEquipments = []
  } = cache;

  let editEquipmentCount =
    cacheEquipments?.filter((equipment) => equipment.equipmentEditingStatus) || [];

  editEquipmentCount = [...editEquipmentCount, ...syncedNewAndEditedEquipments];

  const allSitesCountThatHaveChecks = getAllSitesCountThatHaveANewAndAssignedTasks({
    tasksList: allCheckTasks || []
  });

  const allSitesCountThatHaveInspection = getAllSitesCountThatHaveANewAndAssignedTasks({
    tasksList: allInspectionTasks || []
  });

  const allSitesCountThatHaveNewAndAssignedWOrkOrder = getAllSitesCountThatHaveANewAndAssignedTasks(
    {
      tasksList: allWOTasks || []
    }
  );

  const allSitesCountThatHaveNewAndSyncedWorkRequest = getAllSitesCountThatHaveANewAndAssignedTasks(
    {
      tasksList: newWorkRequestList || []
    }
  );

  const allSitesCountThatHaveNewAndSyncedHSEEvent = getAllSitesCountThatHaveANewAndAssignedTasks({
    tasksList: allHseEvents || []
  });

  const inspectionRunMap = inspection?.inspectionRunMap || {};
  let allRunsInspectionCount = 0;
  let keysOfInspectionRun = Object.keys(inspectionRunMap) || [];
  for (let keyOfInspectionRun of keysOfInspectionRun) {
    let data = inspectionRunMap[keyOfInspectionRun] || {};
    if (data?.allInspections > 0) {
      allRunsInspectionCount += data?.allInspections;
    }
  }

  const recurringTemplatesMap = tasks.recurringTemplatesMap || {};
  let allWOrkOrderRecurringTemplateCount = 0;
  let keysOfRecurringTemplate = Object.keys(recurringTemplatesMap) || [];
  for (let keyOfRecurringTemplate of keysOfRecurringTemplate) {
    let data = recurringTemplatesMap[keyOfRecurringTemplate] || {};
    if (_.isArray(data?.allWorkOrder)) {
      allWOrkOrderRecurringTemplateCount += data?.allWorkOrder?.length || 0;
    } else if (data?.allWorkOrder > 0) {
      allWOrkOrderRecurringTemplateCount += data?.allWorkOrder;
    }
  }

  return {
    // checks
    allCheckTasks,
    allCheckTasksCount: allCheckTasks?.length || 0,
    allSitesCountThatHaveChecks,
    allDoneCheckTasks,
    allDoneCheckTasksCount: allDoneCheckTasks?.length || 0,
    allNotDoneCheckTasks,
    IsCheckOverDue,

    // inspection
    allInspectionTasks,
    allInspectionTasksCount: allInspectionTasks?.length || 0,
    allSitesCountThatHaveInspection,
    allDoneInspectionTasks,
    allDoneInspectionTasksCount: allDoneInspectionTasks?.length || 0,
    IsInspectionOverDue,
    allNotDoneInspectionTasks,

    //  work orders
    allWOTasks,
    allWOTasksCount: allWOTasks?.length || 0,
    newWorkOrderList,
    newWorkOrderListCOunt: newWorkOrderList?.length || 0,
    isWOOverDue,
    allDoneWOTasks,
    allDoneWOTasksCOunt: allDoneWOTasks?.length || 0,
    allDoneTasks,
    allTasks: allTasksList,
    isOverDue,
    allSitesCountThatHaveNewAndAssignedWOrkOrder,

    // work request
    newWorkRequestList,
    newWorkRequestListCOunt: newWorkRequestList?.length || 0,
    allSitesCountThatHaveNewAndSyncedWorkRequest,

    // hse event
    allHseEvents,
    allHseEventsCount: allHseEvents?.length || 0,
    allSitesCountThatHaveNewAndSyncedHSEEvent,

    //  add edit equipment
    editEquipmentCount: editEquipmentCount?.length || 0,
    editEquipmentViewBySitesCount: editEquipmentCount?.length || 0,
    allRunsInspectionCount,
    allWOrkOrderRecurringTemplateCount
  };
};

const allTasksWithPermissions = ({
  permissions,
  allWOTasks,
  allInspectionTasks,
  allCheckTasks
}) => {
  let allTasks = [];
  if (
    permissions[PERMISSIONS.MOBILE_ASSIGNED_CHECKS] &&
    permissions[PERMISSIONS.MOBILE_ASSIGNED_INSPECTIONS] &&
    permissions[PERMISSIONS.MOBILE_ASSIGNED_WORKORDERS]
  )
    allTasks = [...allWOTasks, ...allInspectionTasks, ...allCheckTasks];
  else if (
    permissions[PERMISSIONS.MOBILE_ASSIGNED_CHECKS] &&
    permissions[PERMISSIONS.MOBILE_ASSIGNED_WORKORDERS]
  )
    allTasks = [...allCheckTasks, ...allWOTasks];
  else if (
    permissions[PERMISSIONS.MOBILE_ASSIGNED_INSPECTIONS] &&
    permissions[PERMISSIONS.allCheckTasks]
  )
    allTasks = [...allInspectionTasks, ...allCheckTasks];
  else if (
    permissions[PERMISSIONS.MOBILE_ASSIGNED_INSPECTIONS] &&
    permissions[PERMISSIONS.MOBILE_ASSIGNED_WORKORDERS]
  )
    allTasks = [...allInspectionTasks, ...allWOTasks];
  else if (permissions[PERMISSIONS.MOBILE_ASSIGNED_INSPECTIONS]) allTasks = [...allInspectionTasks];
  else if (permissions[PERMISSIONS.MOBILE_ASSIGNED_WORKORDERS]) allTasks = [...allWOTasks];
  else if (permissions[PERMISSIONS.MOBILE_ASSIGNED_CHECKS]) allTasks = [...allCheckTasks];
  return allTasks;
};

const getAllSitesCountThatHaveANewAndAssignedTasks = ({ tasksList = [] }) => {
  let sitesCount = 0;
  for (let task of tasksList) {
    if (task?.siteId) {
      sitesCount += 1;
    } else if (task?.siteAsset?.sitesIds?.length > 0) {
      sitesCount += task?.siteAsset?.sitesIds?.length; // multiple site ids will come on pipeline
    } else if (
      task?.equipmentAsset?.prepareTasksEquipments?.filter(
        (item) => item.siteAsset && Object.keys(item.siteAsset).length > 0
      )?.length > 0
    ) {
      sitesCount += 1;
    } else if (
      task?.structureData?.structureData?.filter(
        (item) => item.siteAsset && Object.keys(item.siteAsset).length > 0
      )?.length > 0
    ) {
      sitesCount += 1;
    } else if (task?.pipelineAsset?.sitesIds?.length > 0) {
      sitesCount += task?.pipelineAsset?.sitesIds?.length;
    }
  }
  return sitesCount;
};
